import { lazy } from 'react';
import GuestGuard from 'utils/route-guard/GuestGuard';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/authentication/Login')));
const PrivacyNotice = Loadable(lazy(() => import('pages/authentication/PrivacyNotice')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: (
    <GuestGuard>
      <MinimalLayout />
    </GuestGuard>
  ),
  children: [
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'privacy',
      element: <PrivacyNotice />
    }
  ]
};

export default LoginRoutes;
